/* eslint-disable no-param-reassign */
import produce from 'immer';
var genomeFilesDeleted = produce(function (draft, action) {
  var _action$payload = action.payload,
    genomeId = _action$payload.genomeId,
    fileIds = _action$payload.fileIds;
  fileIds.forEach(function (fileId) {
    delete draft.custom[genomeId].files[fileId];
  });
});
export default genomeFilesDeleted;